/**
 * The store's offers as words. Every title, description, banner and FAQ that mentions a deal or the
 * free-shipping amount builds it from here, so changing a number in pricing.ts changes the site.
 */
import { formatCad } from './money.ts';
import { CARTON_DEAL_ENABLED, DEAL_GROUP_SIZE, FREE_SHIPPING_THRESHOLD_CENTS, SHIPPING_FLAT_CENTS } from './pricing.ts';

/** "$125" */
export const FREE_SHIPPING_FROM = formatCad(FREE_SHIPPING_THRESHOLD_CENTS, { whole: true });
/** "$15" */
export const FLAT_SHIPPING = formatCad(SHIPPING_FLAT_CENTS, { whole: true });
/** "buy 6 get the 7th free" */
export const CARTON_DEAL_TEXT = `buy ${DEAL_GROUP_SIZE - 1} get the ${DEAL_GROUP_SIZE}th free`;
/** "free shipping over $125" */
export const FREE_SHIPPING_TEXT = `free shipping over ${FREE_SHIPPING_FROM}`;

/** Every active offer, lower case, for the middle of a sentence: "free shipping over $125". */
export function offerLine(): string {
  return [CARTON_DEAL_ENABLED ? CARTON_DEAL_TEXT : null, FREE_SHIPPING_TEXT].filter(Boolean).join(', ');
}

/** The same, starting a sentence: "Free shipping over $125." */
export function offerSentence(): string {
  const line = offerLine();
  return `${line.charAt(0).toUpperCase()}${line.slice(1)}.`;
}

/** Default text for the announcement bar. */
export function announcementText(): string {
  return [CARTON_DEAL_ENABLED ? `Buy ${DEAL_GROUP_SIZE - 1} cartons, get the ${DEAL_GROUP_SIZE}th free` : null, `Free shipping on orders over ${FREE_SHIPPING_FROM}`]
    .filter(Boolean)
    .join(' · ');
}
